import { render, staticRenderFns } from "./userConservationList.vue?vue&type=template&id=12714709&scoped=true"
import script from "./userConservationList.vue?vue&type=script&lang=js"
export * from "./userConservationList.vue?vue&type=script&lang=js"
import style0 from "./userConservationList.vue?vue&type=style&index=0&id=12714709&prod&lang=scss&scoped=true"
import style1 from "./userConservationList.vue?vue&type=style&index=1&id=12714709&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12714709",
  null
  
)

export default component.exports